<template>
  <div>
    <PCNavbar selectIndex="1" />
    <MobileNavBar :currentActive="0" />
    <CarouselHome />
    <!-- <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center">
          <div class="production_title">萬知的優勢</div>
        </div>
        <div class="inner_right">
          <img src="../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <div class="advantage_out_wrap">
      <el-row class="advantage_wrap">
        <el-col
          class="advantage_item"
          v-for="(item, index) in abList"
          :key="index"
          :span="7"
          :xs="11"
        >
          <div class="item_top">
            <div class="icon hidden-xs-only"><i :class="item.icon"></i></div>
            <div class="tit">{{ item.title }}</div>
          </div>
          <ul
            class="item_desc"
            v-for="(desc, index2) in item.desc"
            :key="index2"
          >
            <li>{{ desc }}</li>
          </ul>
        </el-col>
      </el-row>
    </div> -->
    <div class="bottom_circle">
      <!-- <div class="circle_img">
        <img src="@/assets/img/lineimg.9cc3174a.png" alt="" class="hidden-xs-only"/>
        <img src="@/assets/img/lineimg.9cc3174a.png" alt="" class="hidden-sm-and-up"/>
      </div> -->
    </div>
    <div class="core_options">
      <div class="core_items  is_active">
        香港萬知集團
      </div>
    </div>
    <div class="red-box-container">
      <h1 class="red-box-text">
        立足香港，是致力於文化傳播與知識賦能的綜合性出版集團，旗下擁有科學探索出版社、萬知科學出版社等香港本土出版力量，深耕國際學術出版，秉持"傳播前沿智識，賦能全球學術"宗旨，擁有科研背景深厚、經驗豐富的國際化專業團隊。業務涵蓋期刊全流程管理、學術質量建設、數字化平臺建設及開放獲取探索，另於海南設分社推動港內出版資源整合與雙向流通。集團將以專業嚴謹姿態，與全球學界攜手共譜學術出版與知識傳播新篇章。
      </h1>
    </div>
    <CoreCompetence />
    <!-- <CooperationCustomer /> -->
    <NewsInfomation />
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CarouselHome from "@/components/carousel_home/index";
import TodoShow from "@/components/todo_show/index";
import CoreCompetence from "@/components/core_competence/index";
import CooperationCustomer from "@/components/cooperation_customer/index";
import NewsInfomation from "@/components/news_infomation/index";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    TodoShow,
    CoreCompetence,
    CooperationCustomer,
    NewsInfomation,
    CallMe,
    MobileCallme
  },
  data() {
    return {
      abList: [
        {
          icon: "",
          title: "專業背景",
          desc: [
            "團隊成員具備法學、工學、理學等多學科知識背景",
            "成員擁有多年從業經驗，熟悉國內外知識産權法律法規和審查標準。"
          ]
        },
        {
          icon: "",
          title: "市場優勢",
          desc: [
            "首創 知識産權大數據共享經濟 模式",
            "通過整合海量知識産權數據，挖掘數據價値，為企業和機構提供精準的市場分析和決策依據。"
          ]
        },
        {
          icon: "",
          title: "數據優勢",
          desc: [
            "積極運用大數據、人工智能、區塊鏈等前沿技術",
            "利用大數據分析技術，對海量知識産權數據進行深度挖掘，為企業提供競爭對手分析、行業技術趨勢預測等增値服務"
          ]
        },
        {
          icon: "",
          title: "技術優勢",
          desc: [
            "人工智能技術",
            "實現專利申請文件的智能審核、商標相似性快速比對等功能"
          ]
        },
        {
          icon: "",
          title: "行業影響力",
          desc: [
            "在知識産權服務領域深耕多年",
            "憑借專業的服務團隊、優質的服務質量和良好的客戶口碑，樹立了較高的品牌知名度和美譽度"
          ]
        },
        {
          icon: "",
          title: "政策影響力",
          desc: [
            "推動地方創新發展",
            "加強區域合作交流,利用自身平臺優勢，促進區域間知識産權資源的流動和合作。"
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.bottom_circle {
  width: 100%;
  height: 120px;
  text-align: center;
  background-image: url(../assets/img/smalldot.png),
    url(../assets/img/smalldot1.png);
  background-position: 0 0, 110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
}
.red-box-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin: 0 auto;
  max-width: 65%; // 控製最大寬度
  @media screen and (max-width: 768px) {
    max-width: 95%;
    padding: 0px;
  }
  h1 {
    // background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
    // -webkit-box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.5);
    // box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.5);
    color: #1b1a1a;
    padding: 30px 40px;
    border-radius: 10px;
    font-size: 1.1rem;
    line-height: 1.6;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    font-weight: 500;
    text-align: left;

    @media screen and (max-width: 768px) {
      font-size: 1rem;
      padding: 20px;
      width: 90%;
    }
  }
}
.production_title_wrap {
  width: 100% !important;
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }
  .production_inner {
    display: flex;
    justify-content: center;
    .inner_left {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30%;
      }
    }
    .inner_center {
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 50px;
      @media screen and (max-width: 768px) {
        flex: 2.2;
      }
      .production_title {
        font-size: 40px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
      .production_desc {
        font-size: 16px;
        color: #787878;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
    .inner_right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30%;
      }
    }
  }
}
.advantage_out_wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  .advantage_wrap {
    width: 70%;
    display: flex;
    margin-top: 70px;
    justify-content: center;
    flex-wrap: wrap;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .advantage_item {
      height: auto;
      padding: 30px 20px 60px 20px;
      margin-right: 10px;
      &:nth-child(1) {
        background: url("../assets/img/newEdition/31.png") 90% 10% no-repeat;
        background-size: 20%;
      }
      &:nth-child(2) {
        background: url("../assets/img/newEdition/32.png") 90% 10% no-repeat;
        background-size: 20%;
      }
      &:nth-child(3) {
        background: url("../assets/img/newEdition/32.png") 90% 10% no-repeat;
        background-size: 20%;
      }
      &:nth-child(4) {
        background: url("../assets/img/newEdition/33.png") 90% 10% no-repeat;
        background-size: 20%;
      }
      &:nth-child(5) {
        background: url("../assets/img/newEdition/34.png") 90% 10% no-repeat;
        background-size: 20%;
      }
      &:nth-child(6) {
        background: url("../assets/img/newEdition/35.png") 90% 10% no-repeat;
        background-size: 20%;
      }
      margin: 15px;
      box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);
      @media screen and (max-width: 768px) {
        margin: 0;
        padding: 0 15px;
        margin-top: 3px;
        height: 250px;
        display: flex;
        justify-content: center;
        flex-direction: column;
      }
      .item_top {
        display: flex;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
        .icon {
          i {
            color: #2091d3;
            font-size: 26px;
            padding-right: 10px;
            @media screen and (max-width: 768px) {
              font-size: 2rem;
              margin-bottom: 10px;
            }
          }
        }
        .tit {
          width: 100%;
          color: #1c1c1c;
          font-size: 28px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
            text-align: left;
          }
        }
      }
      .item_desc {
        font-size: 20px;
        line-height: 20px;
        margin: 0;
        padding: 0;
        margin-top: 20px;
        color: #646464;
        list-style: none;
        li {
          line-height: 2rem;
          @media screen and (max-width: 768px) {
            line-height: 1rem;
            font-size: 12px;
          }
          &:first-child {
            margin-top: 30px;
          }
        }
      }
    }
  }
}
.core_options {
  display: flex;
  justify-content: center;
  margin: 20px 0;
  .core_items {
    width: 30%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 1px #04cac7;
    font-size: 30px;
    line-height: 70px;
    user-select: none;
    cursor: pointer;
    margin-bottom: 40px;
    @media screen and (max-width: 768px) {
      width: 65%;
      margin-bottom: 0px;
    }
  }
  .is_active {
    color: #fff;
    font-weight: bold;
    background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
    box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue